import state from './moduleQrCodeState.js'
import mutations from './moduleQrCodeMutations.js'
import actions from './moduleQrCodeActions.js'
import getters from './moduleQrCodeGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
